import React, { useState, useContext } from 'react';
import { UUID } from '__core/utils/types';
import { IJobConfigModel } from '__core/models';
import { IJobSubscriptionViewModel } from '__core/view-models';
import { TableColumnProps } from 'antd';
import { AppContext, useFilters } from '../../state';
import { ItemListView } from 'components/lists/item-list-view';
import { JobSubscriptionViewData } from './item-view';
import { useNavigate } from 'react-router-dom';
import { useShowMessages, useSorter } from 'hooks';
import { subscriptionDurationFormat } from '../subscription/utils';

export const JobSubscriptionViewListView = () => {

    const navigate = useNavigate();

    const { state, dispatch, notify } = useContext(AppContext);
    const [itemLoading, setItemLoading] = useState('');
    const { errorNotification } = useShowMessages();

    const { genericFilters } = useFilters('job-subscriptions');
    const { genericSorter } = useSorter();

    //const customer_id = state.customer?.id || '';
    //const job_id = state.job?.id || '';

    const smallCols: TableColumnProps<IJobSubscriptionViewModel>[] = [
        {
            title: 'Order',
            dataIndex: 'id',
            render: (_, { job_name, order_number, length_years, length_days }) => (
                <>
                    <div>{job_name} - {order_number}</div>
                    <div><i>{subscriptionDurationFormat({ length_years, length_days })}</i></div>
                </>
            ),
            ...genericSorter({ name: 'Order' }),
            ...genericFilters({ name: 'Order' }),
        },
    ]

    const largeCols: TableColumnProps<IJobSubscriptionViewModel>[] = [
        {
            title: 'Customer',
            dataIndex: 'customer_name',
            ...genericSorter({ name: 'customer_name' }),
            ...genericFilters({ name: 'customer_name' }),
        },
        {
            title: 'Job',
            dataIndex: 'job_name',
            ...genericSorter({ name: 'job_name' }),
            ...genericFilters({ name: 'job_name' }),
        },
        {
            title: 'Order Number',
            dataIndex: 'order_number',
            ...genericSorter({ name: 'order_number' }),
            ...genericFilters({ name: 'order_number' }),
        },
        {
            title: 'Part Number',
            dataIndex: 'part_number',
            ...genericSorter({ name: 'active' }),
            ...genericFilters({ name: 'active' }),
        },
        {
            title: 'Quantity',
            dataIndex: 'part_quantity',
            ...genericSorter({ name: 'part_quantity' }),
            ...genericFilters({ name: 'part_quantity' }),
        },
        {
            title: 'Duration',
            dataIndex: 'length_years',
            render: (_, { length_years, length_days }) => subscriptionDurationFormat({ length_years, length_days }),
            ...genericSorter({ name: 'length_years' }),
            ...genericFilters({ name: 'length_years' })
        },
    ]

    const setCustomerJob = async (customer_id: UUID, job_id: UUID) => {
        setItemLoading(job_id);
        try {
            const customerPromise = state.api.read.customer.item({ customer_id })
            const jobPromise = state.api.read.job.item({ customer_id, job_id });
            let config: IJobConfigModel | undefined = undefined;
            try {
                const configPromise = state.api.read.jobConfig.item({ customer_id, job_id });
                config = await configPromise;
            } catch { }
            const customer = await customerPromise;
            const job = await jobPromise;
            if (customer && job) {
                dispatch({ type: 'set-customer', customer });
                dispatch({ type: 'set-job', job, config });
                navigate('/admin/subscriptions');
            }
        } catch {
            errorNotification('Unable to load job.');
        }
        setItemLoading('');
    }

    return (
        <ItemListView
            title='Subscription Overview'
            allowEdit={false}
            itemKey='id'
            loadItemPermission={async () => !!state.userAccount?._is_rbi}
            loadItems={async ({ refresh }) => state.api.read.jobSubscriptionViewModels.list({ refresh })}
            loadViewItem={async ({ item }) => item}
            ViewData={JobSubscriptionViewData}
            smallColumns={smallCols}
            largeColumns={largeCols}
            onSelect={item => setCustomerJob(item.customer_id, item.job_id)}
            columnViewNav={() => `/rbi/subscription-overview`}
            itemLogId={({ id }) => id}
        />
    )
}
